import logo from "../assets/img/blockchain.png";

const Logo = () => {
  return (
    <div className="logo">
      <img src={logo} alt="Logo" />
      <p>Eric R.</p>
    </div>
  );
};

export default Logo;
